import React from 'react'
import { Link } from 'react-router-dom'
import VipLayout from '../../components/vip/VipLayout'

const VipHomePage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container two-col">
          <div>
            <span className="kicker">企业服务 · 互联网/AI资质 · AI合规咨询</span>
            <h1>企业合规服务与 <span className="gradient">AI 资质咨询平台</span></h1>
            <p>聚焦企业工商财税、知识产权、互联网经营资质、AI 大模型登记与备案、开源大模型私有化部署、企业知识库训练与微调，以及社区 / 音视频 / AIGC 服务资质咨询，为企业提供更清晰、更专业、更高效的咨询与申报辅导服务。</p>
            <div className="anchor-nav">
              <Link to="/vip/services">查看服务中心</Link>
              <Link to="/vip/ai-solutions">查看 AI 解决方案</Link>
              <Link to="/vip/contact">立即咨询</Link>
            </div>
          </div>
          <div className="card content-card">
            <h3 style={{marginTop: 0}}>服务定位</h3>
            <p className="lead" style={{fontSize: '16px'}}>我们希望把企业服务从"单一证照咨询"升级为"面向真实业务场景的合规与 AI 咨询平台"。不只帮助客户理解要做什么，更帮助客户理解为什么要做、怎么做、如何与业务和技术路径保持一致。</p>
            <div className="grid cols-2" style={{marginTop: '18px'}}>
              <div className="stat-card card"><div className="stat">5个</div><div>核心服务板块</div></div>
              <div className="stat-card card"><div className="stat">2个</div><div>能力轴：企业资质 + AI 合规</div></div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">五大核心服务板块</h2>
          <p className="section-desc">围绕企业基础经营、互联网服务资质与 AI 新型合规需求，提供系统化咨询服务。</p>
          <div className="grid cols-3" style={{marginTop: '28px'}}>
            <div className="card service-card">
              <h3>企业工商财税咨询</h3>
              <p className="lead" style={{fontSize: '15px'}}>公司注册、变更、注销、财税咨询等基础企业服务。</p>
              <Link className="btn btn-secondary" to="/vip/services/business-finance">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>知识产权咨询</h3>
              <p className="lead" style={{fontSize: '15px'}}>商标、专利、著作权等知识产权服务咨询。</p>
              <Link className="btn btn-secondary" to="/vip/services/intellectual-property">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>网站备案与互联网资质咨询</h3>
              <p className="lead" style={{fontSize: '15px'}}>ICP备案、ICP / EDI 资质申请咨询。</p>
              <Link className="btn btn-secondary" to="/vip/services/internet-licenses">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>AI 资质与备案咨询</h3>
              <p className="lead" style={{fontSize: '15px'}}>算法备案、大模型登记 / 备案、私有化部署、训练与微调咨询。</p>
              <Link className="btn btn-secondary" to="/vip/services/ai-compliance">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>社区 / 音视频 / AIGC 服务资质咨询</h3>
              <p className="lead" style={{fontSize: '15px'}}>网络文化经营许可证、广播电视节目制作经营许可证等咨询服务。</p>
              <Link className="btn btn-secondary" to="/vip/services/content-licenses">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>AI 解决方案</h3>
              <p className="lead" style={{fontSize: '15px'}}>大模型私有化部署、企业知识库、训练微调与智能体应用咨询。</p>
              <Link className="btn btn-secondary" to="/vip/ai-solutions">查看详情</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">为什么选择凡思彼得</h2>
          <div className="grid cols-4" style={{marginTop: '24px'}}>
            <div className="card content-card">
              <h3>服务覆盖更完整</h3>
              <p className="lead" style={{fontSize: '15px'}}>从工商财税到 AI 模型登记、备案与部署咨询，覆盖企业多类需求。</p>
            </div>
            <div className="card content-card">
              <h3>不仅懂政策，也懂技术场景</h3>
              <p className="lead" style={{fontSize: '15px'}}>尤其在算法备案、大模型登记 / 备案、私有化部署、训练微调方向具备理解深度。</p>
            </div>
            <div className="card content-card">
              <h3>标准化服务流程</h3>
              <p className="lead" style={{fontSize: '15px'}}>围绕需求判断、材料准备、申报辅导、审核跟进与交付支持形成清晰链路。</p>
            </div>
            <div className="card content-card">
              <h3>更注重适配而非套模板</h3>
              <p className="lead" style={{fontSize: '15px'}}>根据不同企业业务场景判断真正所需资质、备案与实施路径。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">典型咨询场景</h2>
          <div className="grid cols-3" style={{marginTop: '24px'}}>
            <div className="card content-card"><h3>企业要上线 AI 智能客服，需要做哪些备案？</h3></div>
            <div className="card content-card"><h3>平台提供会员收费或点数收费，是否需要 ICP 经营许可证？</h3></div>
            <div className="card content-card"><h3>基于开源大模型做私有化部署与微调，如何规划备案路径？</h3></div>
            <div className="card content-card"><h3>内容平台或直播平台，什么时候需要网络文化经营许可证？</h3></div>
            <div className="card content-card"><h3>微短剧或音视频内容公司，什么时候需要广播电视节目制作经营许可证？</h3></div>
            <div className="card content-card"><h3>AI 图文 / 视频生成平台，涉及哪些资质和备案？</h3></div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container card content-card">
          <h2 className="section-title" style={{marginTop: 0}}>让企业资质与 AI 合规更清晰、更高效</h2>
          <p className="section-desc">如果你正在准备企业注册、互联网服务资质申请、AI 备案、模型部署或内容服务合规咨询，欢迎与我们沟通。我们将基于你的业务场景，提供更具针对性的路径判断与服务建议。</p>
          <div className="anchor-nav">
            <Link to="/vip/contact">立即咨询</Link>
            <Link to="/vip/services">获取服务方案</Link>
          </div>
        </div>
      </section>
    </VipLayout>
  )
}

export default VipHomePage
